import { ServerRootService } from '@se/platform';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import EstensaModel from 'estensa-module';

@Injectable({
    providedIn: 'root',
})
export class PatientService extends ServerRootService {
    private readonly endPoint = '/Patient/GetPatient';
    private readonly url = this.getServerRoot() + this.endPoint;

    constructor(private httpClient: HttpClient) {
        super();
    }

    getPatientInfo(patientId: string): Observable<EstensaModel.Patient> {
        return this.httpClient.get<EstensaModel.Patient>(this.url, {
            params: { patientId },
        });
    }
}
